/**
 * 菜单路径解析（侧栏高亮 / tab 标题），避免每次切路由全量遍历 menuArr。
 */

function walkMenuItems(menuList, visitor) {
  if (!menuList || !menuList.length) return null;
  for (let groupIndex = 0; groupIndex < menuList.length; groupIndex++) {
    const group = menuList[groupIndex];
    const children = group.children || [];
    for (const item of children) {
      if (item.children && item.children.length > 0) {
        for (const sub of item.children) {
          const hit = visitor(sub, groupIndex, children, group);
          if (hit) return hit;
        }
      } else {
        const hit = visitor(item, groupIndex, children, group);
        if (hit) return hit;
      }
    }
  }
  return null;
}

/** 按路由 path 找侧栏分组与高亮 id */
export function resolveMenuContext(menuList, path, parentPath) {
  const targets = new Set([path, parentPath].filter(Boolean));
  if (!targets.size) return null;

  return walkMenuItems(menuList, (item, groupIndex, children, group) => {
    if (!targets.has(item.amenu_address)) return null;
    return {
      activeMenu: String(group.amenu_id),
      leftmenu: children,
    };
  });
}

/** 按 fullPath 找 tab 标题 */
export function findMenuTitleByPath(menuList, path) {
  if (!path) return "";
  const hit = walkMenuItems(menuList, (item) => {
    if (item.amenu_address !== path) return null;
    return item.amenu_name || "";
  });
  return hit || "";
}
